import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const orderBy = (source, keySelector, comparer) => {
    return OrderedEnumerable.generate(source, keySelector, true, comparer);
};
